const FEEDBACK_MESSAGE_SHOW = 'FEEDBACK_MESSAGE_SHOW';
const FEEDBACK_MESSAGE_HIDE = 'FEEDBACK_MESSAGE_HIDE';

const feedbackMessageShow = (payload) => ({
  type: FEEDBACK_MESSAGE_SHOW,
  payload
});

const feedbackMessageHide = () => ({
  type: FEEDBACK_MESSAGE_HIDE
});

export {
  FEEDBACK_MESSAGE_HIDE,
  FEEDBACK_MESSAGE_SHOW,
  feedbackMessageShow,
  feedbackMessageHide
};
